/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';

@Component({
  standalone: false,
  selector: 'gh-templates-tab-container',
  templateUrl: 'email-template-tab-container.component.html',
})
export class EmailTemplatesTabContainerComponent {
  constructor(public userContext: BuilderUserContext) {
  }
}
